export default "__VITE_ASSET__4MQrzw72__"